import React, {Component} from 'react';
import {connect} from "react-redux";
import _ from 'lodash';
import PropTypes from 'prop-types';

import Button from '../partials/elements/Button';
import {withVFTranslation} from "../../util/withVFTranslation";
import UploadHelper from "../partials/components/UploadHelper";
import colors from "../../util/colors";
import Image from "../partials/elements/Image";
import log from "../../util/log";
import EditLogoCtrl from "../partials/account/general/EditLogoCtrl";
import modalActions from "../../actions/modal-actions";
import SignatureRequest from "../../models/SignatureRequest";
import ValidationErrors from "../partials/components/ValidationErrors";
import utils from "../../util/util";
import Promise from "bluebird";
import PdfSignatureFulfillOverlay from "../partials/pdf-preview/PdfSignatureFulfillOverlay";
import utilityActions from "../../actions/utility-actions";
import PdfWritingSvc from "../../helpers/pdf-writing-svc";
import filters from "../../helpers/filters";
import moment from "moment";
import PdfSigningOverlay from "../partials/pdf-preview/PdfSigningOverlay";
import TextInputMeasurer from "../partials/elements/TextInputMeasurer";
import c from "../../util/const";
import {
  calculateOverlayRelativeScale
} from "../partials/pdf-preview/PdfSignatureRequestOverlay";
import ColorGenerator from "../../helpers/color-generator";
import pdfPreviewActions from "../../actions/pdf-preview-actions";

class PDFFixerDialog extends Component {

  useTestData = false;

  constructor(props) {
    super(props);

    this.state = {
      validation_errors : [],
      textMeasurerRef : null,

      showDownloadButton : false,
      textMeasureQueue : [],
      currentMeasureQueueItem : null,

      uploadedFile : null,
      pdfWriter : null,
      hoveringUpload : false,

      sign_request_id : '',
      parsed_sign_data : null,
      raw_sign_data_json : '',
      signer_data : {},
    }

    if(this.useTestData) {
      this.createDemoData();
    }
  }

  componentDidMount() {
    if(this.props.onRef){
      this.props.onRef(this)
    }
  }

  componentWillUnmount() {
    if(this.props.onRef){
      this.props.onRef(undefined)
    }
  }

  closeModal() {
    let {close} = this.props;

    close();
  }

  createDemoData() {
    this.TEMP_SIG_IMAGE = 'data:image/png;base64,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';
    this.TEMP_INIT_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAAAXNSR0IArs4c6QAABCBJREFUaEPt2FnodHMYB/DPiyihuOAlbuxLSG7sKTdklyU7r33NzoWlENki+5JdQvY1LuwuEEJkl7KTRLIvfet33o5p/nPOzP/MXLzNU1Mz53d+z+/5Ptvv+8wcC4DMWQAwmIKYIYqLIZ+fOo7yilgGb+Pfuu6uI7EQnsdHOKADEKvhWOyPJYu+V7E1fqj0dw1iX9yGk3HxDCBWxff4cQDIhXEWzqi98yQ+xeHlc904QCyNz4rHNseLPUauieuRtYew0wAQd2P3sv4SDsL75fee+BivjAPEpTgOnyBp8E/NyHjvmtrvgDlsBhC74Z6ydgsOxZ+DUrOrdFoPb5aDjsLV5fviuBZJs8gDOBJfDzAqEdwUyf1N8FdTbXUBIjqexpb4FivjF6yFe7E2fsYhSJo0yYPYsUXKzdfTBYg9cFfRmNDfiHm4oTx7Agfjyybry/oVOLqk5Spt9swWxBKlyJbFW6UALyvpkPOTOkmn//X1BsMOxE3lnRXwVROQ2YI4u6cNVuc9WwrywyYD+qyvWxySpV1xX5OO2YBIv+81Mrl/QvFkvTs12VFfX6TWjRLV45s2zwbEw9i+dkB6fzrTF02Htlh/pjSKXHC5nQfKqCCiOAVbSSKwHH7tc1roR9rkHU3G1Nar5vAB1mjaNwqIRQsJW71HeSjCuT3PqosrHSccqK2cj9PwArZo2jQKiOT8JUXxDoUjVYDm4pvaobdjn7YFWtt3YeFfV+KYrkEsX+v3p+Ci4qnnykHx3gW1Qx/FttgILzcZU1u/Hzv3Er2Z9g8biXCZ0OLHkCikA4V+h/iF7/eGvzJml0I52uAIg83FmLsnqRSdnRV2eEwYZSQG17vQ5SXsKfClaieeg9NxJvK9jWyDx5GiXh+/NW1qG4n07tcQondSrSYq/aEVoRm9IKrCzvMAb5r2wrPSXltHIQa0BZH+nyILzQ6x+6PHO5uVsIcAptVWkk4W7h8AoRKhIb/38WzoRQo4NRUJVTmiKQLVehsQ9WLOQFKRvfoZIWoZST/HSj2HZ8+d5Vno9XmlRYfpboi9yqfalvskTmuK2vxj2oDYAK8Xfr8x/u7jobTWELVEqh/zzAAU7w6SOCAT3FNtIzBMJPJuauG7AYwyt+p7pRhnumHTGPYudCK5H6PfKMPUO3ikzCHDYmhdE02Kq871LtZpernU4jD0fKDKNunUwibbFU8m7ZLnE5WuQOyHW8uYutVEEQzRYpvsylia/4EywGSQmah0FYn0/6vKXZAOM1HpCkQuqlCP/PcUljtR6QrEiYWSh8FWt+7EgHQFItPbzcXq/OsRIPXJb6yAugIROn5q4UbhSa2Gma6QdQWiK3tG0jMFMZLbxrBpGokxOHUkldNIjOS2MWyaRmIMTh1J5TQSI7ltDJumkRiDU0dS+R8xLMExKZvibAAAAABJRU5ErkJggg==';
    this.TEMP_CUSTOM_INPUT = JSON.stringify(["aaaa", "bbbb", "ccccc"]);
    this.TEMP_SIGNED_DATE = "3/3/2033";
    this.TEMP_SIG_DATA = JSON.stringify({
      "data": [
        {
          "doc_annotate_id": "624f0dde4c871513",
          "expiry_date": null,
          "ip_address": null,
          "phone": null,
          "request_date": 1649348062,
          "sign_data": {
            "signatures": [
              {
                "height": 30,
                "pageIndex": 0,
                "scale": 1,
                "signatureType": "signature",
                "width": 153,
                "x": 105.5,
                "y": 179
              },
              {
                "height": 30,
                "pageIndex": 0,
                "scale": 1,
                "signatureType": "signed_date",
                "width": 153,
                "x": 135.5,
                "y": 43
              }
            ]
          },
          "sign_order": 1,
          "signed_date": null,
          "signer_email": null,
          "signer_first_name": null,
          "signer_last_name": null,
          "signer_uid": "61d5eacb01e8a9b7",
          "source_doc_id": "624f0d99ad54d7de",
          "terms": null
        },
        {
          "doc_annotate_id": "624f0dde6c2df07b",
          "expiry_date": null,
          "ip_address": null,
          "phone": null,
          "request_date": 1649348062,
          "sign_data": {
            "signatures": [
              {
                "height": 30,
                "pageIndex": 0,
                "scale": 1,
                "signatureType": "initials",
                "width": 153,
                "x": 355.5,
                "y": 360
              }
            ]
          },
          "sign_order": 2,
          "signed_date": null,
          "signer_email": null,
          "signer_first_name": null,
          "signer_last_name": null,
          "signer_uid": "61d7187230ccf45f",
          "source_doc_id": "624f0d99ad54d7de",
          "terms": null
        },
        {
          "doc_annotate_id": "624f0dde6eb78810",
          "expiry_date": null,
          "ip_address": null,
          "phone": null,
          "request_date": 1649348062,
          "sign_data": {
            "signatures": [
              {
                "height": 30,
                "pageIndex": 0,
                "scale": 1,
                "signatureCustomLabel": "some cucstom input",
                "signatureType": "other",
                "width": 153,
                "x": 97.5,
                "y": 496
              }
            ]
          },
          "sign_order": 3,
          "signed_date": null,
          "signer_email": null,
          "signer_first_name": null,
          "signer_last_name": null,
          "signer_uid": "61d7186051c597e0",
          "source_doc_id": "624f0d99ad54d7de",
          "terms": null
        }
      ],
      "success": true
    })

  }

  onMouseEnterUpload() {
    if (this.state.hoveringUpload) {
      return;
    }

    this.setState({hoveringUpload: true});
  }

  onMouseLeaveUpload() {
    this.setState({hoveringUpload: false});
  }

  clearFile() {
    this.setState({
      uploadedFile: null,
    })
  }

  onFileDrop(files, rejectFiles) {
    log.log('onFileDrop', files, rejectFiles)
    if (files.length > 0) {
      this.tryLoadPDF(files[0]);
    }
  }

  tryLoadPDF(fileInput){

    let pdfWriter = new PdfWritingSvc();
    utils.convertFileInputToUIntArray(fileInput)
      .then((res) => {
        pdfWriter.tearDown()
        return pdfWriter.load(res);
      })
      .then((res) => {
        if (!pdfWriter.hasLoaded()) {
          throw new Error('Unable to load PDF writer')
        }

        this.setState({
          uploadedFile: fileInput,
          pdfWriter
        })
      })
      .catch((err) => {
        this.props.modal.showAlert(
          "Unable to load PDF",
          JSON.stringify(err))
      })
  }

  tryParseSigningInput(){
    return new Promise((resolve, reject) => {
      let {
        sign_request_id,
        raw_sign_data_json,
      } = this.state;

      let parsedJSON = null;
      try{
        parsedJSON = JSON.parse(raw_sign_data_json);
      }
      catch(err){
        log.warn('error parsing json', err);
      }

      if(!parsedJSON){
        this.setState({validation_errors : ["Something doesn't look right about that JSON.  Please try again."]})
        resolve(false);
        return;
      }

      log.log('parsed signing', parsedJSON);
      this.setState({
        parsed_sign_data : parsedJSON,
        validation_errors : []
      }, () => {
        resolve(true);

        if(this.useTestData){
          log.log('populating test data', parsedJSON);

          let updatedState = {};
          _.each(parsedJSON.data, (signerBlock) => {
            updatedState[signerBlock.signer_uid] = {
              sign_image : this.TEMP_SIG_IMAGE,
              init_image : this.TEMP_INIT_IMAGE,
              custom_input : this.TEMP_CUSTOM_INPUT,
              signed_date : this.TEMP_SIGNED_DATE
            }
          })
          this.setState({signer_data : updatedState});
        }
      })
    })
  }

  updateSignerData(guest_uid, data){
    let { signer_data } = this.state;

    let update = _.extend({}, signer_data);
    update[guest_uid] = _.extend( {...signer_data[guest_uid]}, {...data});
    this.setState({signer_data : update});
  }

  doValidation(){
    let {
      uploadedFile,
        sign_request_id,
        parsed_sign_data,
        signer_data
    } = this.state;

    let err = [];
    if(!uploadedFile){
      err.push("Please select a pdf to modify");
    }
    if(!sign_request_id){
      err.push("Please enter a sign_request_id");
    }

    let hasSignerDataError = false;
    _.each(parsed_sign_data.data, (signerBlock) => {
      let signDataSignatures = _.get(signerBlock, 'sign_data.signatures', []);
      let sign_data = signer_data[signerBlock.signer_uid];

      let sign_image = _.get(sign_data, 'sign_image', '');
      let init_image = _.get(sign_data, 'init_image', '');
      let customInput = _.get(sign_data, 'custom_input', '');
      let signedDate = _.get(sign_data, 'signed_date', '');

      let needSignatures = _.find(signDataSignatures,
        (s) => s.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.SIGNATURE);
      let needInitials = _.find(signDataSignatures,
        (s) => s.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.INITIALS);
      let needCustomInput = _.find(signDataSignatures,
        (s) => s.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.OTHER);
      let needCustomSignedDate = _.find(signDataSignatures,
        (s) => SignatureRequest.isSignedDate(s.signatureType));

      if(needSignatures && sign_image.length === 0){
        hasSignerDataError = true;
      }
      if(needInitials && init_image.length === 0){
        hasSignerDataError = true;
      }
      if(needCustomInput && customInput.length === 0){
        hasSignerDataError = true;
      }
      if(needCustomSignedDate && signedDate.length === 0){
        hasSignerDataError = true;
      }

      if(hasSignerDataError){
        return false;
      }
    })

    if(hasSignerDataError){
      err.push("It looks like you are missing data for one of your signers.");
    }

    this.setState({validation_errors : err})
    return err.length === 0;
  }

  processSignDataSignatures(signatures){

    //Apply a couple conversions that ensure things look right in web.
    //This is duplicated in pdfActions.loadSignatureOverlaysIfNeeded()

    let result = [];
    _.each(signatures, (sig) => {
      if(sig.scale !== 1){
        sig = _.extend({}, sig,
          {
            x : sig.x / sig.scale,
            y : sig.y / sig.scale,
            width : sig.width / sig.scale,
            height : sig.height / sig.scale,
            scale : 1
          })
      }
      var scale = sig.scale || 1;
      sig.height = sig.height / scale;
      sig.width = sig.width / scale;

      result.push(sig);
    })
    return result;
  }

  generatePdf(){
    if(!this.doValidation()){
      return;
    }

    let {
      sign_request_id,
      parsed_sign_data,
      signer_data,

      pdfWriter
    } = this.state;

    return this.writeSignatureWatermarks(sign_request_id)
      .then(() => {

        let promises = [];
        _.each(parsed_sign_data.data, (signerBlock) => {

          let signDataSignatures = this.processSignDataSignatures(_.get(signerBlock, 'sign_data.signatures', []));

          let sign_data = signer_data[signerBlock.signer_uid];
          let sign_image = _.get(sign_data, 'sign_image');
          let init_image = _.get(sign_data, 'init_image');
          let customInput = JSON.parse(_.get(sign_data, 'custom_input', "[]"));
          let signedDate = _.get(sign_data, 'signed_date', '');

          let lastUsedCustomInputIndex = 0;
          _.each(signDataSignatures, (sig) => {
            if (sig.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.SIGNATURE || sig.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.INITIALS) {
              let image = sig.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.SIGNATURE ? sign_image : init_image
              promises.push(
                this.generateSignatureImage(image, sig.width, sig.height)
                  .then((img) => {
                    //I think this is what we need?  this forces the view scale to be 1
                    let overlayX = calculateOverlayRelativeScale(sig.x, sig.scale, 1);
                    let overlayY = calculateOverlayRelativeScale(sig.y, sig.scale, 1);

                    return pdfWriter.drawImage(sig.pageIndex, overlayX, overlayY, sig.scale, img.width, img.height, img.data)
                  })
              )
            }
            else if(sig.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.OTHER){
              let overlayX = calculateOverlayRelativeScale(sig.x, sig.scale, 1);
              let overlayY = calculateOverlayRelativeScale(sig.y, sig.scale, 1);

              let text = customInput[lastUsedCustomInputIndex];
              lastUsedCustomInputIndex++; //move to next item in list
              let font = PdfSigningOverlay.FONTS.HELVETICA;

              promises.push(
                this.doMeasureText(text, sig)
                  .then((measuredFontSize) => {
                    return pdfWriter.drawText(sig.pageIndex, overlayX, overlayY, sig.scale, text, font, measuredFontSize)
                  })
              )
            }
            else if(SignatureRequest.isSignedDate(sig.signatureType)){
              let overlayX = calculateOverlayRelativeScale(sig.x, sig.scale, 1);
              let overlayY = calculateOverlayRelativeScale(sig.y, sig.scale, 1);

              //this is the original code that supports non-utc
              //however we need to force utc since we don't know what timezone the target is.
              // let text = SignatureRequest.isSignedDateUTC(sig.signatureType) ?
              //           filters.momentUTCFilter(moment(signedDate).unix(), SignatureRequest.getDateMaskForSignatureType(sig.signatureType)) :
              //           filters.momentFilter(moment(signedDate).unix(), SignatureRequest.getDateMaskForSignatureType(sig.signatureType))

              let text = filters.momentUTCFilter(moment(signedDate).unix(), SignatureRequest.getDateMaskForSignatureType(sig.signatureType));
              let font = PdfSigningOverlay.FONTS.COURIER;

              promises.push(
                this.doMeasureText(text, sig)
                  .then((measuredFontSize) => {
                    return pdfWriter.drawText(sig.pageIndex, overlayX, overlayY, sig.scale, text, font, measuredFontSize)
                  })
              )
            }
            else{
              throw new Error('Unknown signature type');
            }
          })

        })

        return Promise.all(promises);
      })
      .then((res) => {
        log.log('done writing signature points!', res);
        this.setState({showDownloadButton : true});
      })
      .catch((err) => {
        log.log('error writing signature points', err);
      })
  }

  downloadPdf(){
    this.state.pdfWriter.getUintPdfData()
      .then((bytes) => {
        const file = new Blob([bytes], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        const pdfWindow = window.open();
        pdfWindow.location.href = fileURL;
      })
  }

  generateSignatureImage(image, width, height){
    return new Promise((resolve, reject) => {
      utils.calculateResizedImage(image, width, height)
        .then((newDimensions) => {
          resolve({
            width : newDimensions.width,
            height : newDimensions.height,
            data : image
          })
        })
        .catch((err) => {
          reject(err);
        })
    })
  }

  writeSignatureWatermarks(sign_request_id){
    let { t } = this.props;

    let { pdfWriter } = this.state;

    return this.props.generateWatermarkImg(t("Signed via Verifyle: ") + sign_request_id)
      .then((watermarkImg) => {
        return Promise.map(pdfWriter.getAllPages(), (page, index) => {

          //I wish we didn't need to know about page rotation here.  We should really try and
          //keep this logic confined to the pdfWriter.
          //since we're hardcoding the watermark coords to bottom right, we need to know if there's a page rotation present.

          let pageRotation = page.getRotation();
          let flipIt = pageRotation.angle === 90 || pageRotation.angle === 270;

          let watermarkX = null;
          let watermarkY = null;
          let dimensions = pdfWriter.getPageDimensions(page);
          if(flipIt){
            watermarkX = dimensions.height - (watermarkImg.width);
            watermarkY = dimensions.width - (watermarkImg.height);
          }
          else{
            watermarkX = dimensions.width - (watermarkImg.width);
            watermarkY = dimensions.height - (watermarkImg.height);
          }

          return pdfWriter.drawImage(index, watermarkX, watermarkY, 1, watermarkImg.width, watermarkImg.height, watermarkImg.data)
        })
      })
      .then(() => {
        log.log('watermarks written successfully');
      })
      .catch((err) => {
        log.error('error writing watermarks', err);
      })
  }

  processTextMeasureQueue(){
    //need to deal with this properly, dump in queue, one at a time.
    if(this.state.currentMeasureQueueItem){
      //log.log('processTextMeasure called with active item', this.state.currentMeasureQueueItem);
      //already running here.  do nothing.
      return;
    }

    let update = _.concat([], this.state.textMeasureQueue);
    let itemToProcess = _.pullAt(update, 0)

    // log.log('processTextMeasure queue', itemToProcess);
    this.setState({
      textMeasureQueue : update,
      currentMeasureQueueItem : itemToProcess.length > 0 ? itemToProcess[0] : null
    }, () => {
      if(!this.state.currentMeasureQueueItem){
        //done.
        return;
      }

      utils.waitForCondition(() => this.state.textMeasurerRef)
        .then((res) => {
          // log.log('done waiting for text measure ref');
          let measurer = _.get(this.state, 'textMeasurerRef');
          let currentMeasureQueueItem = _.get(this.state, 'currentMeasureQueueItem');
          let initialFontSize = SignatureRequest.isSignedDate(currentMeasureQueueItem.signature.signatureType) ? PdfSignatureFulfillOverlay.INITIAL_CUSTOM_INPUT_FONT_SIZE : PdfSignatureFulfillOverlay.INITIAL_CUSTOM_INPUT_FONT_SIZE;
          measurer.startMeasure(currentMeasureQueueItem.text, initialFontSize, currentMeasureQueueItem.signature.width)
            .then((measuredFontSize) => {
              // log.log('done measuring point', currentMeasureQueueItem, measuredFontSize);
              this.setState({
                currentMeasureQueueItem : null
              }, () => {
                currentMeasureQueueItem.resolve(`${measuredFontSize}px`);
                this.processTextMeasureQueue();
              })
            })
            .catch((err) => {
              log.warn('error during measuring', err);
              currentMeasureQueueItem.reject(err);
            })
        })
    })
  }

  doMeasureText(text, signature){
    return new Promise((resolve, reject) => {
      let update = _.concat(this.state.textMeasureQueue, [{
        item_id : _.uniqueId('measure-queue'),
        text,
        signature,
        resolve,
        reject
      }]);

      // log.log('push item to measure', text, signature, update);
      this.setState({textMeasureQueue : update}, () => {
        this.processTextMeasureQueue();
      })
    })
  }

  renderPDFUploadControls(){
    let { t } = this.props;
    let {
      uploadedFile,
      hoveringUpload
    } = this.state;

    return (
      <div className={'row'}>
        <div className="col-4">

        </div>
        <div className={'col-4'}>
          <div className="form-group">
            {!uploadedFile &&
              <UploadHelper allowMultiple={false}
                            preventDragOverlay={true}
                            onDrop={this.onFileDrop.bind(this)}>
                {({isDragActive}) => {
                  let panelColorStyle = null;
                  if(isDragActive){
                    panelColorStyle = {color : colors.PRIVATE_GREEN};
                  }
                  else if(hoveringUpload){
                    panelColorStyle = {color : colors.PRIMARY};
                  }
                  else{
                    panelColorStyle = {color : colors.DARK};
                  }

                  return (
                    <div className={`drag-drop-panel`}
                         onMouseEnter={this.onMouseEnterUpload.bind(this)}
                         onMouseLeave={this.onMouseLeaveUpload.bind(this)}
                         style={{...EditLogoCtrl.styles.dragDropEmpty, ...panelColorStyle, ...(hoveringUpload ? EditLogoCtrl.styles.dragDropEmptyHover : null)}}>
                      <div className="text-center">
                        <i style={EditLogoCtrl.styles.dragDropIcon} className={`icon ion-upload`}/>
                      </div>
                      <span>{isDragActive ? t('Ready!') : t('Drag and Drop or Click to Browse')}</span>
                    </div>
                  )
                }}
              </UploadHelper>
            }
            {uploadedFile &&
              <div style={EditLogoCtrl.styles.dragDrop}>
                <Button className={'btn btn-dark no-focus'} style={EditLogoCtrl.styles.clearButton}
                        onClick={this.clearFile.bind(this)}>
                  <i className="icon ion-close"/>
                </Button>
                Uploaded File: {uploadedFile.name}
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  renderSigningInputs(){
    let { t } = this.props;
    let {
      raw_sign_data_json,
      sign_request_id
    } = this.state;

    return (
      <div className="row">
        <div className="offset-3 col-6">
          <div className="form-group">
            <label>{t("Sign Request ID")}</label>
            <input className={'form-control'}
                   type={'text'}
                   value={sign_request_id}
                   onChange={(evt) => this.setState({sign_request_id: evt.target.value})}
                   placeholder={t('Sign Request ID here')} />
          </div>
          <div className="form-group">
            <label>{t("Sign Data (json)")}</label>
            <textarea className={'form-control'}
                   value={raw_sign_data_json}
                   onChange={(evt) => this.setState({raw_sign_data_json: evt.target.value})}
                   placeholder={"{\n" +
                     "   \"data\" : [\n" +
                     "      {\n" +
                     "         \"sign_data\" : {...}"} />
          </div>
          <div className="form-group text-end">
            <Button className={'btn btn-primary '}
                    onClick={this.tryParseSigningInput.bind(this)}>
              {t("Parse!")}
            </Button>
          </div>
        </div>
      </div>
    )
  }

  renderSignData(){
    let { t } = this.props;
    let {
      parsed_sign_data,
      signer_data
    } = this.state;

    if(!parsed_sign_data){
      return null;
    }

    // log.log('renderSignData render', parsed_sign_data, signer_data);
    return (
      <div className="row">
        <div className="offset-3 col-6">
          {_.map(parsed_sign_data.data, (signerBlock) => {

            let signDataSignatures = _.get(signerBlock, 'sign_data.signatures', []);
            let sign_data = signer_data[signerBlock.signer_uid];

            let sign_image = _.get(sign_data, 'sign_image', '');
            let init_image = _.get(sign_data, 'init_image', '');
            let customInput = _.get(sign_data, 'custom_input', '');
            let signedDate = _.get(sign_data, 'signed_date', '');

            let needSignatures = _.find(signDataSignatures,
              (s) => s.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.SIGNATURE);
            let needInitials = _.find(signDataSignatures,
              (s) => s.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.INITIALS);
            let needCustomInput = _.find(signDataSignatures,
              (s) => s.signatureType === SignatureRequest.SIGNATURE_REQUEST_TYPE.OTHER);
            let needCustomSignedDate = _.find(signDataSignatures,
              (s) => SignatureRequest.isSignedDate(s.signatureType));

            return (
              <div key={signerBlock.signer_uid}>
                <p className="fw-bold">Guest uid: {signerBlock.signer_uid}</p>
                {needSignatures &&
                  <div className="form-group">
                    <label>{t("Signature Image")}</label>
                    <input className={'form-control'}
                           type={'text'}
                           value={sign_image}
                           onChange={(evt) => this.updateSignerData(signerBlock.signer_uid, {sign_image: evt.target.value})}
                           placeholder={'data:image/png;base64,iVBORw0KGgoAAAANSU...'}/>
                  </div>
                }
                {needInitials &&
                  <div className="form-group">
                    <label>{t("Initials Image")}</label>
                    <input className={'form-control'}
                           type={'text'}
                           value={init_image}
                           onChange={(evt) => this.updateSignerData(signerBlock.signer_uid, {init_image: evt.target.value})}
                           placeholder={'data:image/png;base64,iVBORw0KGgoAAAANSU...'}/>
                  </div>
                }
                {needCustomInput &&
                  <div className="form-group">
                    <label>{t("Custom Input Array")}</label>
                    <input className={'form-control'}
                           type={'text'}
                           value={customInput}
                           onChange={(evt) => this.updateSignerData(signerBlock.signer_uid, {custom_input: evt.target.value})}
                           placeholder="An array of strings, in order of  eg ['aaaa','bbbb','ccccc']"/>
                  </div>
                }
                {needCustomSignedDate &&
                  <div className="form-group">
                    <label>{t("Signed Date")}</label>
                    <input className={'form-control'}
                           type={'text'}
                           value={signedDate}
                           onChange={(evt) => this.updateSignerData(signerBlock.signer_uid, {signed_date: evt.target.value})}
                           placeholder="Anything you can parse, eg 3/3/2033"/>
                  </div>
                }
                <div>
                  <label>{t("Signatures")}</label>
                  {_.map(signDataSignatures, (s, i) => {
                    return (
                      <p key={i}>
                        {JSON.stringify(s)}
                      </p>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderFinishControls(){
    let {
      parsed_sign_data,
      validation_errors,
      showDownloadButton
    } = this.state;

    if(!parsed_sign_data){
      return null;
    }

    return (
      <div className="row">
        <div className="offset-3 col-6">
          {validation_errors.length > 0 &&
            <div className={'row'}>
              <div className={'col'}>
                <ValidationErrors errors={validation_errors}/>
              </div>
            </div>
          }

          {!showDownloadButton &&
            <div className="text-end">
              <Button className={'btn btn-primary'}
                      onClick={this.generatePdf.bind(this)}>
                Generate PDF
              </Button>
            </div>
          }
          {showDownloadButton &&
            <div className="text-end">
              <Button className={'btn btn-primary'}
                      onClick={this.downloadPdf.bind(this)}>
                Download PDF
              </Button>
            </div>
          }

        </div>
      </div>
    )
  }

  renderTextMeasurer(){
    let {
      currentMeasureQueueItem
    } = this.state;

    if(!currentMeasureQueueItem){
      return null;
    }

    // log.log('renderTextMeasurer', currentMeasureQueueItem);
    let measureBufferSpace = SignatureRequest.isSignedDate(currentMeasureQueueItem.signature.signatureType) ? 29: 12;

    return (
      <TextInputMeasurer onRef={(ref) => this.setState({textMeasurerRef: ref})}
                         measureBufferSpace={measureBufferSpace}
                         fontClass={SignatureRequest.isSignedDate(currentMeasureQueueItem.signature.signatureType) ? PdfSigningOverlay.FONTS.COURIER : PdfSigningOverlay.FONTS.HELVETICA}
                         scaleRelativeToOverlay={(val) => calculateOverlayRelativeScale(val, currentMeasureQueueItem.signature.scale, 1)} />
    )
  }

  onEscapeKey(){
    this.closeModal(false);
  }

  render() {
    let {modalProps, t} = this.props;

    return (
      <div className="modal-content">
        <div className="modal-header draggable-header">
          <h5 className="modal-title">PDF fixer</h5>
          <button type="button" className="close" onClick={this.closeModal.bind(this)} aria-label={t("Close")}>
            <i className="icon ion-ios-close-empty" />
          </button>
        </div>
        <div className="modal-body">
          {this.renderTextMeasurer()}
          {this.renderPDFUploadControls()}
          {this.renderSigningInputs()}
          {this.renderSignData()}
          {this.renderFinishControls()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modal : {
      ...modalActions.mapToDispatch(dispatch),
    },
    generateWatermarkImg : (watermarkText) => dispatch(utilityActions.generateWatermarkImg(watermarkText)),
  };
};

PDFFixerDialog.propTypes = {
  close : PropTypes.func.isRequired,
  onRef : PropTypes.func,
  modalProps : PropTypes.object.isRequired
}

export default withVFTranslation()(connect(mapStateToProps, mapDispatchToProps)(PDFFixerDialog));
